import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class UserPlatformsService {
  getUserPlatforms() {
    return ApiService.get(`${Config.api.auth.url}users/current/platforms?hasAccessOnly=true`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }

  mapError(error) {
    if (error.response.data) {
      return error.response.data;
    } else if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
}

export const userPlatformsService = new UserPlatformsService();
